import React, { useEffect, useState } from "react";

const CountdownTimer = ({
  expiry_date,
  isExpired,
  isDelete = false,
  ApprovedStatus,
  enquiry_closed,
  ScreenName = "",
}) => {
  const [timeLeft, setTimeLeft] = useState(null);
  const [isTimeUp, setIsTimeUp] = useState(false);

  useEffect(() => {
    if (isExpired || isDelete || enquiry_closed || !expiry_date) return; // No countdown if expired or deleted or closed

    // Format expiry_date to ISO string and remove microseconds
    const formattedExpiryDate = expiry_date?.replace(" ", "T")?.split(".")?.[0]; // Replace space with T and remove microseconds
    const expiryTimeUTC = new Date(formattedExpiryDate); // Parse the expiry date in UTC

    // Adjust to your specific timezone (e.g., YST)
    const timezoneOffset = new Date().getTimezoneOffset() * 60000; // Get timezone offset in milliseconds
    const expiryTime = new Date(expiryTimeUTC?.getTime() - timezoneOffset); // Adjust time to local timezone

    const interval = setInterval(() => {
      const now = new Date(); // Current local time
      const difference = expiryTime - now;

      if (difference <= 0) {
        // Stop timer once it reaches 0 or negative
        clearInterval(interval);
        setIsTimeUp(true);
        setTimeLeft("00h:00m");
      } else {
        const totalHours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60),
        );

        if (totalHours >= 24) {
          const days = Math.floor(totalHours / 24);
          const hours = totalHours % 24;
          setTimeLeft(
            `${days}d ${String(hours).padStart(2, "0")}h:${String(minutes).padStart(2, "0")}m`,
          );
        } else {
          setTimeLeft(
            `${String(totalHours).padStart(2, "0")}h:${String(minutes).padStart(2, "0")}m`,
          );
        }
      }
    }, 1000);

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [expiry_date, isExpired, isDelete, enquiry_closed]);

  if (!timeLeft || isExpired || isDelete || enquiry_closed || timeLeft === "00h:00m") {
    return null;
  }

  return (
    <div
      style={{ color: "rgb(171, 16, 16)", fontSize: "11px", fontWeight: "400" }}
    >
      {ScreenName === "my enquiries - quotation summary" ? (
        <span>Expires in {timeLeft}</span>
      ) : (
        <span>
          Expires in <br />
          {timeLeft}
        </span>
      )}
    </div>
  );
};

export default CountdownTimer;
